import ReactDOM from "react-dom/client";
import React, { useEffect, useState, useRef } from "react";
import useAuth from "./../../hooks/useAuth";
import {
  doPost,
  OPENAPI,
  CountWords,
  handleCopyClick,
  handleSaveContent,
  do_update_token,
} from "./../../utils/apiCalls";
import {Translate } from "react-auto-translate";
import COPYICON from "./../../assets/images/copy_icon.svg";
import DELICON from "./../../assets/images/del_icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { setTokens } from "../../lib/Redux/slices/userslice";

const ImageResponse = ({ loading, responseAI, contentCategory, image_data }) => {
  const { NotificationsToasts = null } = useSelector((state) => state.user);

  const dispatch = useDispatch();
  const { Tokenvalue = 0 } = useSelector((state) => state.web);
  const [newresponseAI, setNewResponseAI] = useState([]);
  console.log("responseAI", responseAI);
  console.log("image_data", image_data);
  console.log(newresponseAI, "NEW RESPONSE AI");
  const { getLoggedObject, setLoggedObject, isLoggedIn, checkLogin } =
    useAuth();
  const do_update_response = (v) => {
    if (responseAI.length > 1) {
      const new_content = v;

      return new_content;
    } else {
      return v;
    }
  };

  useEffect(() => {
    setNewResponseAI(responseAI);
  }, [responseAI]);
  
  useEffect(() => {
    const fetch = async () => {
      let last = responseAI[responseAI.length - 1];
      let length = CountWords(last);
  const response = await do_update_token(length, getLoggedObject()?.token ,NotificationsToasts );
      if (response) {
        dispatch(setTokens(response));
      }
    };
    fetch();
  }, [responseAI]);

  const do_update_ai_content = async (ind, event) => {
    const updatedResponseAI = [...newresponseAI];
    updatedResponseAI[ind] = event;
    setNewResponseAI(updatedResponseAI);
  };

  return (
    <>
      <div className="card tool_car_right_response">
        <div className="ai-board-header card-title h5" />
        <div className="ai-board-body card-body">
          {loading && (
            <div className="genMoreLoad">
              <div className="loaderWrap">
                <strong>
                  <Translate>Generating content...</Translate>
                </strong>
                <p>
                  <Translate>
                    please wait a few seconds for it to load.
                  </Translate>
                </p>
                <div className="loader"></div>
              </div>
            </div>
          )}
          {!loading && newresponseAI == "" && (
            <div className="noResults">
              <h5>
                <i>🚀</i> <Translate>Get start now...</Translate>
              </h5>
              <p>
                <Translate>
                  Generate high quality content by adding your inputs
                </Translate>
              </p>
            </div>
          )}

          {newresponseAI != "" && (
            <>
              {newresponseAI.map((v, i) => (
                <div
                  className="ai-section height-align text-center"
                  key={"response_" + i}
                >
                  <div className="ai-content">
                    <div>
                      <div
                        className="editableContent"
                        contenteditable="true"
                        style={image_data == 1 ? { textAlign: "center" } : {}}
                        onBlur={(event) => {
                          // event.preventDefault();
                          do_update_ai_content(
                            i,
                            event.currentTarget.innerText
                          );
                        }}
                      >
                        {image_data == 1 ? (
                          <>
                            <img src={v} style={{ width: "400px" }} />
                          </>
                        ) : (
                          do_update_response(v)
                        )}
                      </div>
                    </div>
                    <span className="index">{i + 1}</span>
                    <div className="btn-group-wrap text-right">
                      <div className="float-left display-flex">
                        {image_data == 1 ? (
                          <></>
                        ) : (
                          <span className="wordCount float-left">
                            <Translate>Words:</Translate> {CountWords(v)}
                          </span>
                        )}
                      </div>
                      <div
                        className="svg_button"
                        style={{ pointerEvents: "auto" }}
                      >
                        <button
                          onClick={() => handleCopyClick(v ,NotificationsToasts)}
                          type="button"
                          id={0}
                          className="btn btn-outline-secondary btn-sm"
                        >
                          <img src={COPYICON} />{" "}
                          <Translate>
                            Copy {image_data == 1 ? "Image Url" : ""}
                          </Translate>{" "}
                        </button>
                        {image_data == 1 ? (
                          <></>
                        ) : (
                          <button
                            type="button"
                            id={0}
                            className="ml-1  btn btn-outline-secondary btn-sm"
                            onClick={() =>
                              handleSaveContent(
                                v,
                                contentCategory,
                                CountWords(v),
                                getLoggedObject()?.token,
                                NotificationsToasts
                              )
                            }
                          >
                            <img src={DELICON} /> <Translate>save</Translate>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ImageResponse;
